import { render } from "./FooterProductCategoriesComponent.vue?vue&type=template&id=1b56e13c"
import script from "./FooterProductCategoriesComponent.vue?vue&type=script&lang=js"
export * from "./FooterProductCategoriesComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"platform/themes/iteam/assets/js/components/FooterProductCategoriesComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1b56e13c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1b56e13c', __exports__)) {
    api.reload('1b56e13c', __exports__)
  }
  
  module.hot.accept("./FooterProductCategoriesComponent.vue?vue&type=template&id=1b56e13c", () => {
    api.rerender('1b56e13c', render)
  })

}


export default __exports__